import { LoaderService } from './../loder_service/loader.service';
import { DataService } from './../data.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  about_info:any;
  constructor(public restApi:DataService,public toastService:LoaderService) { }

  ngOnInit() {}
ionViewWillEnter(){
//   this.toastService.showLoader('')
//  this.restApi.get_about_info().subscribe((data:any)=>{
//    this.about_info=data.about_info;
//    this.toastService.hideLoader()
//  },(error:any)=>{
//   this.toastService.hideLoader()
//  })
}
}
